import { render, staticRenderFns } from "./supplyDetail.vue?vue&type=template&id=66a194d7&scoped=true"
import script from "./supplyDetail.vue?vue&type=script&lang=js"
export * from "./supplyDetail.vue?vue&type=script&lang=js"
import style0 from "./supplyDetail.vue?vue&type=style&index=0&id=66a194d7&prod&lang=less"
import style1 from "./supplyDetail.vue?vue&type=style&index=1&id=66a194d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a194d7",
  null
  
)

export default component.exports